import axios from 'axios';
import api from '../config/api';
import config from 'config';
import moment from 'moment';
import { Cookies } from 'react-cookie';
import { merge } from 'lodash';
import { voliaExtraLogin } from 'actions/profile/helpers';
import Platform from 'platform';

export const wait = (ms = 1000) => new Promise((resolve) => setTimeout(resolve, ms));

export default async function requester({
  method = 'get',
  url,
  data,
  appendParams = true,
  headers = {},
  extendHeadersWithSession = true,
  params = {},
  ...rest
}) {
  const cookies = new Cookies();

  const defaultParams = {
    deviceType: Platform.getDeviceType(),
  };

  if (url.indexOf('/public/') !== -1) {
    defaultParams.tenantId = api.tenantId;
  }

  // TODO добавить проверку, что в урле от бекенда уже пришли deviceType или tenantId
  // и не добавлять повторно
  params = appendParams ? { ...params, ...defaultParams } : params;

  const modifiedHeaders =
    extendHeadersWithSession && cookies.get('x-session-id')
      ? merge({ 'x-session-id': cookies.get('x-session-id') }, headers)
      : headers;

  try {
    const response = await axios({
      method,
      url,
      data,
      headers: modifiedHeaders,
      withCredentials: false,
      validateStatus: function (status) {
        return status >= 200 && status < 300; // default
      },
      params,
      ...rest,
    });
    if (response.headers['x-session-id']) {
      cookies.set('x-session-id', response.headers['x-session-id'], {
        path: '/',
      });
    }

    if (response.headers['date']) {
      if (!config.serverTime) {
        config.serverTime = response.headers['date'];
        config.timeDiffFromServer = -moment().diff(moment(config.serverTime), 'm');
      }
    }

    return response.data;
  } catch (error) {
    // Это может быть внутрення ошибка
    if (!error.response) throw error;

    const { status } = error.response;

    if (status !== 401) throw error;
    // В течении работы приложения сессия сожет "протухнуть"
    // и тогда все запросы будут сыпаться с 401 ошибкой
    // в таком случае нужно переавторизовать пользователя
    // с новым токеном и повторить запрос
    console.log(status, typeof status);
    try {
      await voliaExtraLogin();
      return await requester({
        method,
        url,
        data,
        params,
        headers,
        extendHeadersWithSession,
        ...rest,
      });
    } catch (error) {
      console.log({ error });
      throw error;
    }
  }
}
